'use client';

import { Suspense } from 'react';

import { useTargetRecommendationContents } from './models';
import PersonalizedContentsSkeleton from './parts/Skeleton';

import { PersonalizedContents as PersonalizedContentsFeature } from '@/features/Landing';
import { RecommendationArticleParams } from '@/entities/article';

const PersonalizedContentsBody = ({
  year,
  role,
}: RecommendationArticleParams) => {
  const { data: personalizedContents } = useTargetRecommendationContents({
    year,
    role,
  });

  return (
    <PersonalizedContentsFeature personalizedContents={personalizedContents} />
  );
};

const PersonalizedContents = (props: RecommendationArticleParams) => {
  return (
    <Suspense fallback={<PersonalizedContentsSkeleton />}>
      <PersonalizedContentsBody {...props} />
    </Suspense>
  );
};

export default PersonalizedContents;
